import React from 'react';
import Grid from '@material-ui/core/Grid';
import HomeItemsCreation from 'UI/components/templates/HomeItemsCreation';
import { getId } from 'UI/utils';

/**
 * @param {Object} props
 * @param {Array<ColumnParam>} props.columnsParam
 * @param {number} [props.coachId]
 * @param {number} [props.regionalId]
 */
const HomeItemsRenderer = ({ columnsParam, coachId, regionalId }) => {
  if (!columnsParam) return null;

  return (
    <Grid container direction="row" spacing={2} role="grid">
      {columnsParam.map(column => (
        <Grid item sm={column.size} xs={column.xsSize} key={getId()}>
          <Grid container direction="column" spacing={2} role="list">
            {column.items &&
              column.items.map(item => {
                return (
                  <Grid item xs={12} key={item.name}>
                    <HomeItemsCreation item={{ ...item, coachId, regionalId }} role="listitem" />
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default HomeItemsRenderer;
